import { createEvent, createEffect, sample } from 'effector';
import { gameModel } from 'entities/game';
import { createModalSwitcher } from 'shared/lib';

const switcher = createModalSwitcher();

const returnHome = createEvent();

const returnHomeFx = createEffect((homeUrl: string) => {
	const top = window.top ?? window;

	top.location.href = homeUrl;
});

sample({
	clock: returnHome,
	source: gameModel.$returnUrl,
	filter: Boolean,
	target: returnHomeFx,
});

export const sidebarModel = {
	switcher,
	returnHome,
};
